(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wm-og-wmx-rotating-headline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wmx-rotating-heading')) {
  customElements.define('wmx-rotating-heading', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.start());
    }
    start() {
      if (!this.isConnected || this.controller) return;
      this.items = [...this.querySelectorAll('[data-wmx-headline]')];
      if (this.items.length < 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.index = Math.max(0, this.items.findIndex(item => item.dataset.state === 'active'));
      this.delay = Math.min(8000, Math.max(2000, Number(this.dataset.interval) || 2000));
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = true;
      this.hovered = null;
      this.focused = null;
      const sync = () => this.schedule();
      document.addEventListener('visibilitychange', sync, options);
      this.reduced.addEventListener('change', sync, options);
      this.motionObserver = new MutationObserver(sync);
      this.motionObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-wmx-motion'] });
      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting);
          this.schedule();
        });
        this.visibilityObserver.observe(this);
      }
      const welcome = this.closest('[data-wmx-new-home]');
      welcome?.querySelectorAll('[data-wmx-headline-target]').forEach(target => {
        const key = target.dataset.wmxHeadlineTarget;
        target.addEventListener('pointerenter', event => {
          if (event.pointerType === 'touch') return;
          this.hovered = key;
          this.selectTarget();
        }, options);
        target.addEventListener('pointerleave', () => {
          if (this.hovered === key) this.hovered = null;
          this.selectTarget();
        }, options);
        target.addEventListener('focusin', () => {
          this.focused = key;
          this.selectTarget();
        }, options);
        target.addEventListener('focusout', event => {
          if (target.contains(event.relatedTarget)) return;
          if (this.focused === key) this.focused = null;
          this.selectTarget();
        }, options);
      });
      this.schedule();
    }
    selectTarget() {
      const key = this.focused || this.hovered;
      const index = this.items.findIndex(item => item.dataset.wmxHeadline === key);
      if (index !== -1) this.show(index);
      this.schedule();
    }
    show(index) {
      if (index === this.index) return;
      const previous = this.index;
      this.index = index;
      this.items.forEach((item, position) => {
        item.dataset.state = position === index ? 'active' : position === previous ? 'leaving' : 'waiting';
      });
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || !this.controller || this.reduced.matches || document.hidden || !this.inView || this.hovered || this.focused || document.documentElement.dataset.wmxMotion === 'paused') return;
      this.timer = setTimeout(() => {
        this.show((this.index + 1) % this.items.length);
        this.schedule();
      }, this.delay);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
      this.motionObserver?.disconnect();
      this.visibilityObserver?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wmx-home-base"] && !Shopify.designMode) return;
  try {
    (() => {
  const bind = scope => {
    const galleries = [];
    if (scope.matches?.('[data-wmx-gallery]')) galleries.push(scope);
    scope.querySelectorAll?.('[data-wmx-gallery]').forEach(gallery => galleries.push(gallery));
    galleries.forEach(gallery => {
      if (gallery.dataset.wmxBound) return;
      gallery.dataset.wmxBound = 'true';
      const filters = [...gallery.querySelectorAll('[data-wmx-filter]')];
      const products = [...gallery.querySelectorAll('[data-wmx-treatment]')];
      const list = gallery.querySelector('.wmx-home__products');
      const status = gallery.querySelector('[data-wmx-results]');
      filters.forEach(button => button.addEventListener('click', () => {
        if (button.getAttribute('aria-pressed') === 'true') return;
        const update = () => {
          filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          let count = 0;
          products.forEach(product => {
            const visible = button.dataset.wmxFilter === 'all' || button.dataset.wmxFilter === product.dataset.wmxTreatment;
            product.hidden = !visible;
            if (visible) count += 1;
          });
          if (status) status.textContent = count === 1 ? status.dataset.one : status.dataset.many.replace('__COUNT__', String(count));
          if (list) list.scrollLeft = 0;
        };
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (document.startViewTransition && !reduce && document.documentElement.dataset.wmxMotion !== 'paused') document.startViewTransition(update);
        else update();
      }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind(document), { once: true });
  else bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
  document.addEventListener('shopify:block:select', event => {
    const card = event.target.closest('[data-wmx-treatment]');
    if (!card) return;
    const gallery = card.closest('[data-wmx-gallery]');
    gallery?.querySelector('[data-wmx-filter="all"]')?.click();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wmx-rotating-headline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wmx-rotating-heading')) {
  customElements.define('wmx-rotating-heading', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.start());
    }
    start() {
      if (!this.isConnected || this.controller) return;
      this.items = [...this.querySelectorAll('[data-wmx-headline]')];
      if (this.items.length < 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.index = Math.max(0, this.items.findIndex(item => item.dataset.state === 'active'));
      this.delay = Math.min(8000, Math.max(2000, Number(this.dataset.interval) || 2000));
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = true;
      this.hovered = null;
      this.focused = null;
      const sync = () => this.schedule();
      document.addEventListener('visibilitychange', sync, options);
      this.reduced.addEventListener('change', sync, options);
      this.motionObserver = new MutationObserver(sync);
      this.motionObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-wmx-motion'] });
      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting);
          this.schedule();
        });
        this.visibilityObserver.observe(this);
      }
      const welcome = this.closest('[data-wmx-new-home]');
      welcome?.querySelectorAll('[data-wmx-headline-target]').forEach(target => {
        const key = target.dataset.wmxHeadlineTarget;
        target.addEventListener('pointerenter', event => {
          if (event.pointerType === 'touch') return;
          this.hovered = key;
          this.selectTarget();
        }, options);
        target.addEventListener('pointerleave', () => {
          if (this.hovered === key) this.hovered = null;
          this.selectTarget();
        }, options);
        target.addEventListener('focusin', () => {
          this.focused = key;
          this.selectTarget();
        }, options);
        target.addEventListener('focusout', event => {
          if (target.contains(event.relatedTarget)) return;
          if (this.focused === key) this.focused = null;
          this.selectTarget();
        }, options);
      });
      this.schedule();
    }
    selectTarget() {
      const key = this.focused || this.hovered;
      const index = this.items.findIndex(item => item.dataset.wmxHeadline === key);
      if (index !== -1) this.show(index);
      this.schedule();
    }
    show(index) {
      if (index === this.index) return;
      const previous = this.index;
      this.index = index;
      this.items.forEach((item, position) => {
        item.dataset.state = position === index ? 'active' : position === previous ? 'leaving' : 'waiting';
      });
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || !this.controller || this.reduced.matches || document.hidden || !this.inView || this.hovered || this.focused || document.documentElement.dataset.wmxMotion === 'paused') return;
      this.timer = setTimeout(() => {
        this.show((this.index + 1) % this.items.length);
        this.schedule();
      }, this.delay);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
      this.motionObserver?.disconnect();
      this.visibilityObserver?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wmx-visual-enhancements"] && !Shopify.designMode) return;
  try {
    (() => {
  function start() {
    const settings = document.getElementById('wmx-visual-settings');
    if (!settings || window.wmxVisualsActive) return;
    window.wmxVisualsActive = true;
    const root = document.documentElement;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = false;
    try { paused = sessionStorage.getItem('wmx-motion-paused') === 'true'; } catch (_) {}
    const products = [
      ['wmx-studio-semaglutide', 'semaglutide'],
      ['weight-care-hero-unbranded-2026-09-23', 'tirzepatide'],
      ['wmx-studio-hormone', 'hormone'],
      ['wmx-studio-hair', 'hair'],
      ['wmx-studio-energy', 'energy'],
      ['wmx-studio-sexual-health', 'sexual'],
      ['wmx-studio-nad', 'nad']
    ];
    const images = new WeakSet();
    const cards = new WeakSet();
    function syncMotion() {
      const stopped = paused || reduced.matches || document.hidden;
      root.dataset.wmxMotion = stopped ? 'paused' : 'playing';
      document.querySelectorAll('.wmx-motion-toggle').forEach(button => {
        button.textContent = paused ? settings.dataset.resume : settings.dataset.pause;
        button.dataset.paused = String(paused);
        button.setAttribute('aria-pressed', String(paused));
      });
    }
    function controls(host, floating = false) {
      if (!host || host.querySelector('.wmx-motion-controls')) return;
      const row = document.createElement('div');
      row.className = 'wmx-motion-controls' + (floating ? ' wmx-motion-controls--floating' : '');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'wmx-motion-toggle';
      button.addEventListener('click', () => {
        paused = !paused;
        try { sessionStorage.setItem('wmx-motion-paused', String(paused)); } catch (_) {}
        syncMotion();
      });
      row.append(button);
      host.append(row);
    }
    const visibility = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => entry.target.classList.toggle('wmx-product-visible', entry.isIntersecting));
    }, { threshold: .15 }) : null;
    function attachImage(img) {
      const source = [img.getAttribute('src'), img.getAttribute('data-src'), img.getAttribute('srcset')].join(' ');
      const product = products.find(([filename]) => source.includes('/' + filename));
      if (!product || images.has(img)) return;
      images.add(img);
      img.dataset.wmxProduct = product[1];
      img.alt = settings.dataset[product[1] + 'Alt'];
      img.width = 1254;
      img.height = 1254;
      if (img.style.getPropertyValue('--pf-image-ratio')) img.style.setProperty('--pf-image-ratio', '1');
      if (visibility) visibility.observe(img);
      else img.classList.add('wmx-product-visible');
      controls(img.closest('.wmc-landing-artwork'));
    }
    function attachHome() {
      const home = document.querySelector('[data-wmx-home]');
      if (!home) return;
      const treatments = [
        ['.pf-336_', '#edf0e8'], ['.pf-348_', '#e9eff4'],
        ['.pf-360_', '#f1ece8'], ['.pf-372_', '#f0f0df']
      ];
      treatments.forEach(([selector, tint]) => {
        const card = home.querySelector(selector);
        if (card && !card.classList.contains('wmx-treatment-card')) {
          card.classList.add('wmx-treatment-card');
          card.style.setProperty('--wmx-card-tint', tint);
        }
      });
      const groups = [
        ['card', 'cardtext', '#faf3e6', '#806236'],
        ['card2', 'cardtext1', '#edf2f5', '#486172'],
        ['card3', 'cardtext2', '#f2f2e6', '#606215'],
        ['card4', 'cardtext3', '#f8eeec', '#8c3434']
      ];
      groups.forEach(([id, textId, tint, ink]) => {
        const card = home.querySelector('#' + id);
        if (!card || cards.has(card)) return;
        cards.add(card);
        card.style.setProperty('--wmx-category-bg', tint);
        const text = home.querySelector('#' + textId);
        if (text) text.style.color = ink;
        const activate = () => groups.forEach(([, labelId]) => {
          const label = home.querySelector('#' + labelId);
          if (label) label.dataset.wmxCategoryActive = String(labelId === textId);
        });
        card.addEventListener('pointerenter', activate);
        card.addEventListener('focusin', activate);
      });
      const featured = home.querySelector('.wmx-treatment-card')?.closest('section');
      if (featured && !featured.querySelector('.wmx-image-caption')) {
        const caption = document.createElement('p');
        caption.className = 'wmx-image-caption';
        caption.textContent = settings.dataset.imageCaption;
        featured.append(caption);
      }
      // A page-level control is available before the first moving product.
      controls(home.querySelector('#card')?.closest('section'));
    }
    function scan(scope) {
      if (scope.nodeType !== Node.ELEMENT_NODE) return;
      if (scope.matches('img')) attachImage(scope);
      scope.querySelectorAll('img').forEach(attachImage);
      attachHome();
      if (document.querySelector('img[data-wmx-product], .wmx-treatment-art, wmx-rotating-heading, wmx-glp1-journey') && !document.querySelector('.wmx-motion-controls')) controls(document.body, true);
      syncMotion();
    }
    scan(document.body);
    const queued = new Set();
    let scheduled = false;
    new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'attributes') queued.add(record.target);
        else record.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE && !node.closest('.wmx-motion-controls,.wmx-image-caption')) queued.add(node);
        });
      });
      if (!queued.size || scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        queued.forEach(node => { if (node.isConnected) scan(node); });
        queued.clear();
        scheduled = false;
      });
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset', 'data-src'] });
    reduced.addEventListener('change', syncMotion);
    document.addEventListener('visibilitychange', syncMotion);
    document.addEventListener('shopify:section:load', event => scan(event.target));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
